import { m8API } from 'services/production/m8';
import { normalizeM8UserFullInfo } from 'services/production/utils/normalizeM8UserFullInfo';
import { GetClientService } from 'types/services';

export const getClient: GetClientService = async (clientId) => {
  const [m8UserFullInfo, m8LegalRequisites] = await Promise.all([
    m8API.admin.getUser(clientId),
    m8API.admin.getUserLegalRequisites({ idUser: clientId }),
  ]);

  return normalizeM8UserFullInfo(m8UserFullInfo).toClient(m8LegalRequisites);
};
